export var Appearance = {
  Warning: 'warning',
  Standard: 'standard',
  Danger: 'danger',
  Success: 'success',
  Premium: 'premium',
  Preview: 'preview',
  ExperimentalDark: 'experimentalDark'
};